// INTELIMOVE-ARQ-005A (IM-UI-147) — síntese breve do Radar na tela Hoje; detalhes sob demanda.
import { Link } from 'react-router-dom';
import type { RadarEvent } from '@intelimove/contracts';
import { AsyncView } from './States';
import { useResource } from '../hooks/useResource';
import { relativeTime } from '../data/adapters';
import { radarApi } from '../data/radar';

const CONFIDENCE: Record<string, string> = { ALTA: 'Confiança alta', MEDIA: 'Confiança média', BAIXA: 'Confiança baixa' };
const STATE: Record<string, string> = { NOVO: 'Novo', ATUALIZACAO_RELEVANTE: 'Atualização relevante', DESATUALIZADO: 'Precisa ser reavaliado', CONFLITO: 'Informações conflitantes' };

function RadarItem({ item }: { item: RadarEvent }) {
  return (
    <li className="xp-radar-item">
      <div className="xp-radar-top"><span className={`xp-radar-level level-${item.relevance.toLowerCase()}`}>{item.relevanceLabel}</span><time dateTime={item.occurredAt}>{relativeTime(item.occurredAt)}</time></div>
      <h3>{item.title}</h3>
      <p className="xp-radar-entity">{item.entity.name} · {STATE[item.state] ?? item.state}</p>
      <p>{item.change}</p>
      <p className="xp-radar-why"><b>Por que importa:</b> {item.whyItMatters}</p>
      <div className="xp-radar-actions"><Link className="link-btn" to={item.action.href}>{item.action.label}</Link><span>{item.confidence ? CONFIDENCE[item.confidence] : 'Confiança não determinada'}</span></div>
      <details className="xp-why">
        <summary>Ver evidências e limites</summary>
        {item.evidence.length ? <ul className="plain-list">{item.evidence.map((e) => <li key={e.id}>{e.url ? <a href={e.url} target="_blank" rel="noreferrer">{e.title ?? e.sourceName ?? 'Fonte original'}</a> : <span>{e.title ?? e.sourceName ?? 'Referência preservada'}</span>} <span className="cell-sub inline">· {e.informationState.toLowerCase()}</span></li>)}</ul> : <p className="xp-quiet">Nenhuma evidência verificável está disponível para este item.</p>}
        {item.opportunityImpact && <p><b>Avaliação atual:</b> {item.opportunityImpact.classificationLabel}. {item.opportunityImpact.summary}</p>}
        {item.limitations.length > 0 && <p className="cell-sub">Limites: {item.limitations.join(' ')}</p>}
      </details>
    </li>
  );
}

export function OpportunityRadarPanel() {
  const { state, reload } = useResource((signal) => radarApi.list(5, 0, signal), []);
  return (
    <section className="xp-radar" aria-labelledby="xp-radar-title">
      <div className="xp-section-head"><div><p className="xp-eyebrow">Radar de oportunidades</p><h2 id="xp-radar-title">Novidades que merecem sua atenção</h2><p>Mudanças nas informações que você acompanha, priorizadas pelo possível impacto comercial.</p></div><Link className="link-btn" to="/acompanhar">Ver acompanhamento</Link></div>
      <AsyncView state={state} onRetry={reload} empty={null} loading="block">
        {(radar) => radar.items.length > 0 ? <ul className="xp-radar-list" role="list">{radar.items.map((item) => <RadarItem key={item.id} item={item} />)}</ul> : (
          <div className="xp-radar-empty">
            <p>{radar.monitoring.configured ? 'Nenhuma mudança importante identificada nas informações acompanhadas.' : 'Configure o acompanhamento para receber novidades sobre empresas e concorrentes.'}</p>
            {!radar.monitoring.configured && <Link className="xp-secondary" to="/fontes">Configurar acompanhamento</Link>}
            {radar.monitoring.configured && radar.monitoring.lastRunAt && <span>Última execução {relativeTime(radar.monitoring.lastRunAt)}.</span>}
          </div>
        )}
      </AsyncView>
    </section>
  );
}
